'use client'

import { PricingRulesModel } from '@marketplace-web/domain/escrow-pricing-data'

import IntroductionSection from './IntroductionSection'
import PriceRuleSection from './PriceRuleSection'
import AdditionalInformationSection from './AdditionalInformationSection'

type Props = {
  priceRules: PricingRulesModel
}

const AvailableDiscountLandingPage = ({ priceRules }: Props) => (
  <div className="available_discounts__landing-page">
    <div className="available_discounts__landing-page-container">
      <IntroductionSection />
      <div>
        {priceRules.map(priceRule => (
          <PriceRuleSection key={priceRule.id} priceRule={priceRule} />
        ))}
      </div>
      <AdditionalInformationSection />
    </div>
  </div>
)

export default AvailableDiscountLandingPage
